export const OTHER_PAYMENT_METHOD_ID = -1;

export const HighReceiptAmountThresholdSEK = 4000;

export const SkatteverketReceiptVATRequirementsUrl =
  "https://www.skatteverket.se/foretag/moms/kopavarorochtjanster/kopavarorellertjanstertillforetaget.4.7459477810df5bccdd480005156.html";

const Fuel = 1;
const ComputersAndAccessories = 2;
const OfficeSupplies = 3;
const Other = 5;
const Postage = 7;
const ITServiceOrSoftware = 9;
const Advertising = 15;
const OtherLinkedToCustomerDelivery = 17;

export const ReceiptCategoryTypesRequiringVATWarning: number[] = [
  Fuel,
  ComputersAndAccessories,
  OfficeSupplies,
  Other,
  Postage,
  ITServiceOrSoftware,
  Advertising,
  OtherLinkedToCustomerDelivery,
];
